import { render } from "./ward.vue?vue&type=template&id=3ee0fefc&scoped=true"
import script from "./ward.vue?vue&type=script&lang=js"
export * from "./ward.vue?vue&type=script&lang=js"

import "./ward.vue?vue&type=style&index=0&id=3ee0fefc&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee0fefc"]])

export default __exports__